// extracted by mini-css-extract-plugin
export default {"rating":"yK-z","numberOfStars":"zK-z","count":"AK-z","barGraphSpacing":"BK-z","barGraph":"CK-z"};